module.exports = __webpack_public_path__ + "static/media/introduction-05.a700772e.png";